import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Subject } from 'rxjs';

import { BaseRendererComponent, FormService, IdDescription, ModalService, UtilityService } from 'tms-lib';
import { LocationReferenceService, StockItemHeaderReceiptService } from 'tms-web-shared';

@Component({
  selector: 'app-location-select-renderer',
  templateUrl: './location-select-renderer.component.html',
  styleUrl: './location-select-renderer.component.scss',
  imports: [NgSelectComponent, FormsModule, AsyncPipe],
})
export class LocationSelectRendererComponent extends BaseRendererComponent implements OnInit, ICellRendererAngularComp {
  private readonly locationReferenceService = inject(LocationReferenceService);
  private readonly stockItemHeaderReceiptService = inject(StockItemHeaderReceiptService);
  private readonly utilityService = inject(UtilityService);
  private readonly formService = inject(FormService);
  private readonly modalService = inject(ModalService);

  static warehouseIdChanged = new Subject<number>();

  private modalLevel: number;

  ngOnInit() {
    this.modalLevel = this.modalService.modalLevel;
    this.monitorWarehouseId();
  }

  public onChange(event: any) {
    this.params.node.setDataValue(this.colId, event.value);
    if (this.isAggregate) return;

    switch (this.colId) {
      case 'warehouseId':
        LocationSelectRendererComponent.warehouseIdChanged.next(this.rowIndex);
        break;
      case 'locationId':
        this.stockItemHeaderReceiptService
          .amendStockAlreadyReceived(this.rowData)
          .pipe(this.untilDestroyed())
          .subscribe(() => this.formService.resetForms(this.modalLevel));
        break;
    }
  }

  private monitorWarehouseId() {
    if (this.colId === 'locationId' && !this.isAggregate) {
      LocationSelectRendererComponent.warehouseIdChanged.pipe(this.untilDestroyed()).subscribe((rowIndex: number) => {
        if (rowIndex === this.rowIndex) {
          this.locationReferenceService
            .getForWarehouse(this.rowData.warehouseId)
            .pipe(this.untilDestroyed())
            .subscribe((locations: IdDescription[]) => {
              this.params.context.options = this.utilityService.mapSelectOptions(locations);
              if (!locations.find((x) => x.id === this.cellData)) {
                this.setDataValue(this.colId, undefined);
              }
            });
        }
      });

      LocationSelectRendererComponent.warehouseIdChanged.next(this.rowIndex);
    }
  }
}
